/* eslint-disable no-undef */

import { Base64 } from '../utils/encrypt';

export class Types {
  static GET = 1;

  static POST = 2;

  static MULTIPART = 3;
}

class Request {
  url = undefined;

  type = Types.GET;

  payload = undefined;

  tag = undefined;

  headers = undefined;
}
export { Request };

export const SOMETHING_WRONG = 9999;
export const INTERNET_NOT_CONNECTED = 498;
export const ENCRYPTED_KEY = Base64.btoa('1c1c1_acc_opening');
